var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":_vm.$settings.routerAnimation,"mode":"out-in"}},[_c('keep-alive',{attrs:{"include":['Error404','ErrorOffline']}},[_c('router-view')],1)],1),_c('env-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }